// Keep this in sync with ContactUs.java
export const contactFormTypes = {
    TEACHER: 'TEACHER',
    DONOR: 'DONOR',
};

export const donorSupportCategoriesWithProjectInput = {
    'make-donation': true,
    site: true,
};

export const donorSupportCategoriesWithDonationInput = {
    'previous-donation': true,
    'donor-promo-misc': true,
    'donor-promo-forgot': true,
    'donor-contact-teacher': true,
    'donor-other': true,
};

export const donorSupportCategoriesWithoutMessageInput = {
    'donor-promo-forgot': true,
    donorcodesexpired: true,
};

export const donorSupportCategoriesWithPromoCodeInput = {
    'donor-promo-misc': true,
    'donor-promo-forgot': true,
};

export const donorSupportCategoriesWithGiftCodeInput = {
    'donor-gift-card': true,
    donorcodesother: true,
};

export const donorSupportCategoriesWithGiftCodeInputs = {
    donorcodesexpired: true,
};

export const donorSupportCategoriesWithPartnershipsInput = {
    'partnership-cash': true,
    'partnership-options': true,
    'partnership-product': true,
    'partnership-proceeds': true,
};

export const donorSupportCategoriesWithReferrerSelectInput = {
    'partnership-cash': true,
    'partnership-options': true,
};

export const partnerReferrers = [
    'A Friend or Colleague',
    'A company or foundation that has worked with DonorsChoose',
    'DonorsChoose Blog',
    'DonorsChoose Employee',
    'Event or Conference',
    'Google or other search',
    'Media (Press, News, TV)',
    'My Employer or Client',
    'Social Media',
    'A Teacher',
    'Other',
];

export const extensionReasons = [
    'project materials late or not received',
    'Project not complete',
    'Thank-you package just mailed',
    'Personal matter',
    'Technical difficulties',
    'Other',
];

export const donorPromoCodeCategoryIds = {
    'promo-codes': 64,
    'forgot-promo-code': 74,
};

export const teacherSupportCategoriesWithSchoolAddressInput = {
    teacherreferral: true,
    account: true,
    eligibility: true,
    teacheraccountother: true,
};

export const teacherSupportCategoriesWithTYPInput = {
    extend: true,
    typ1: true,
    photo: true,
    thankyousstatus: true,
};

export const teacherSupportCategoriesWithTYPExtensionInput = {
    extend: true,
};

export const teacherDraftableProjectCategories = {
    postedchange: true,
};

export const teacherSupportCategoriesWithPromoCodeInput = {
    'teacher-promo-retroactive': true,
};

export const teacherSupportCategoriesWithResourceInputs = {
    vendor: true,
    magazine: true,
    matnotarrived: true,
};

export const teacherSupportCategoriesWithResourceIssueInputs = {
    vendor: true,
    magazine: true,
};

export const teacherSupportCategoriesWithGiftCodeInputs = {
    teacheraccountexpiredcode: true,
    teacherprojectexpiredcode: true,
};

export const teacherSupportCategoriesWithoutSignIn = {
    eligibility: true,
    teacheraccountother: true,
    login: true,
};
